export const getPercentage = (price, basePrice) => {
    return 100 - Math.round((price / basePrice)*100);
}